import { rem } from 'polished';
import styled from 'styled-components/macro';

export const StyledNarrowerContainer = styled.div`
  margin: 0 auto;
  margin-top: ${rem('40px')};
  padding: 0 10%;

  & > *:last-child {
    margin-bottom: 0;
    margin-top: ${rem('32px')};
  }

  @media screen and (max-width: ${({ theme }) => theme.breakpoints.l}) {
    width: 100%;
  }
`;
